import React from 'react';
import ProjectsGraphQlController from '../../../controllers/projectsGraphQl';
import { ReactComponent as DownIcon } from '../../../assets/svg/arrow-ios-downward.svg';
import { ReactComponent as AssignIcon } from '../../../assets/svg/assign-equipment.svg';
import { ReactComponent as ReceiveIcon } from '../../../assets/svg/receive-equipment.svg';
import { ReactComponent as SmalDownIcon } from '../../../assets/svg/s-chevron-down.svg';
import { withRouter } from '../../../services/withRoute';
import LoadingBar from '../../components/global/loadingBar';
import Chart from 'chart.js/auto';
import { Pie } from 'react-chartjs-2';
import { gql } from '@apollo/client';
import _ from 'lodash';

const getEquipmentSummary = gql`
	query EquipmentSummary {
		equipmentSummary {
			type
			typeCount
			models {
				model
				count
				status
			}
		}
	}
`;

class EquipmentsOverview extends ProjectsGraphQlController {
	constructor() {
		super();
		this.state = {
			isLoading: true,
			equipmentSummary: [],
			pieData: {
				labels: ['Assigned', 'Ready'],
				datasets: [
					{
						data: [80, 20],
						backgroundColor: ['#FDB946', '#479A5F'],
						hoverBackgroundColor: ['#FDB946', '#479A5F'],
						//hoverOffset: 10,
						borderWidth: 0,
					},
				],
			},
		};
	}

	componentDidMount = () => {
		this.getEquipmentSummary(getEquipmentSummary, {});
	};

	handleExpandCollapseSingle = (index = null, type = null) => {
		let equipmentSummary = this.state.equipmentSummary;
		if (index !== null) {
			equipmentSummary[index].isExpanded = !equipmentSummary[index].isExpanded;
		}
		if (type === 'expand-all') {
			_.forEach(equipmentSummary, (item, index) => {
				item.isExpanded = true;
				return item;
			});
		} else if (type === 'collapse-all') {
			_.forEach(equipmentSummary, (item, index) => {
				item.isExpanded = false;
				return item;
			});
		}

		this.setState({
			equipmentSummary,
		});
	};

	render() {
		const pieConfig = {
			maintainAspectRatio: false,
			responsive: false,
			plugins: {
				legend: {
					display: false,
				},
			},
			legend: {
				display: false,
			},
			elements: {
				arc: {
					borderWidth: 0,
				},
			},
			layout: {
				padding: 10,
			},
		};
		return (
			<div className="layout-wrapper">
				{this.state.isLoading ? (
					<div className="container">
						<LoadingBar />
					</div>
				) : (
					<div className="container">
						<div className="searchContainer borderBottom">
							<a className="title">Equipments</a>
							<div className="right-container">
								<span
									className="collapse-expand-btn up-arrow"
									onClick={() =>
										this.handleExpandCollapseSingle(null, 'collapse-all')
									}
								>
									<span className="down-icn">
										<DownIcon />
									</span>
									<span className="btn-title">Collapse all</span>
								</span>
								<span
									className="collapse-expand-btn"
									onClick={() =>
										this.handleExpandCollapseSingle(null, 'expand-all')
									}
								>
									<span className="down-icn">
										<DownIcon />
									</span>
									<span className="btn-title">Expand all</span>
								</span>
								{/* <span className="add-edit-btn">
									<span className="add-icn">
										<AssignIcon />
									</span>
									<span className="add-title">Assign Equipment</span>
								</span>
								<span className="add-edit-btn">
									<span className="add-icn">
										<ReceiveIcon />
									</span>
									<span className="add-title">Receive Equipment</span>
								</span> */}
							</div>
						</div>
						<div className="equipment-overview-container">
							{_.map(this.state.equipmentSummary, (equipment, index) => {
								return (
									<div
										className="collapsible-item-container"
										key={`${equipment.type + index}`}
									>
										<div
											className="collapse-expand-top-header"
											onClick={() => this.handleExpandCollapseSingle(index)}
										>
											<span
												className={
													'collapse-icn' +
													(equipment.isExpanded === true
														? ' expanded'
														: '')
												}
											>
												<SmalDownIcon />
											</span>
											<div className="collpage-top-right-wrapper">
												<span
													className="collapse-title"
													title={
														equipment.type.charAt(0).toUpperCase() +
														equipment.type
															.replace(/([A-Z])/g, ' $1')
															.slice(1)
													}
												>
													{equipment.type.charAt(0).toUpperCase() +
														equipment.type
															.replace(/([A-Z])/g, ' $1')
															.slice(1)}
												</span>
												<div className="collapse-info-container">
													<span className="info-text green">
														{equipment.readyCount}
													</span>
													<span className="info-text yellow">
														{equipment.assignedCount}
													</span>
													<span className="info-text">
														{equipment.total}
													</span>
												</div>
											</div>
										</div>
										{equipment.isExpanded === false ? null : (
											<div className="collapsible-body-container">
												{_.map(equipment.typeModels, (model, key) => {
													return (
														<div
															className="eq-card-container"
															key={`${key}`}
														>
															<div className="card-title-container">
																<div className="card-title">
																	{key}
																</div>
																<div className="card-title-count-container">
																	<span className="count-text green">
																		{model.ready}
																	</span>
																	<span className="count-text plus">
																		+
																	</span>
																	<span className="count-text red">
																		{model.busy}
																	</span>
																</div>
															</div>
															<div className="card-bottom-stats-container">
																<span
																	className="stats-green"
																	style={
																		model.busy + model.ready >
																			0 && model.ready > 0
																			? {
																					minWidth: `${
																						(model.ready *
																							100) /
																						(model.ready +
																							model.busy)
																					}%`,
																			  }
																			: {}
																	}
																></span>
																<span
																	className="stats-red"
																	style={
																		model.busy + model.ready >
																			0 && model.busy > 0
																			? {
																					minWidth: `${
																						(model.busy *
																							100) /
																						(model.ready +
																							model.busy)
																					}%`,
																			  }
																			: {}
																	}
																></span>
															</div>
														</div>
													);
												})}
											</div>
										)}
									</div>
								);
							})}
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default withRouter(EquipmentsOverview);
